import React, { useState } from "react";

import {
  Tooltip,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  Avatar,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

// import { useMutation, useQuery } from "@apollo/client"
//icons
import { CiCircleList } from "react-icons/ci";
import { FaRegEye } from "react-icons/fa";
import { BiMinusCircle } from "react-icons/bi";
import EmptyImage from "../../Assets/empty-image.png";

//src
import "../../Style/dialogstyle.scss";

export default function ViewMeterialUnit({ open, handleClose, editData }) {
  // console.log("editDatView  ", editData?.materialId?.materialEnName);

  return (
    <div>
      <Dialog open={open} className="dialog-container" fullWidth maxWidth="md">
        <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
          <Stack direction="row" spacing={2}>
            <Stack direction="column" justifyContent="center">
              <Typography className="dialog-title">
                ពិនិត្យលម្អិតសម្ភារៈ
              </Typography>
            </Stack>

            <Box sx={{ flexGrow: 1 }} />
            <Stack direction="column" justifyContent="center">
              <IconButton onClick={handleClose}>
                <BiMinusCircle className="close-icon" />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          {/* {editData?.map((row, index) => {
            return (
              <Grid container rowSpacing={4} columnSpacing={2} key={index}>
                <Grid item xs={12}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                
                    <h1>
                      {row?.materialId?.materialEnName || "Unknown Material"}
                    </h1>

                  
                    <Box
                      sx={{
                        height: "160px",
                        width: "500px",
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "8px",
                        boxShadow: 2,
                      }}
                    >
                      <img
                        src={row?.imageSrc ? row?.imageSrc : EmptyImage}
                        alt="Preview"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain", 
                        }}
                      />
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            );
          })} */}

          <Stack
            direction="column"
            spacing={2}
            sx={{ width: "100%" }}
            className="view-dialog-contanier"
            mt={2}
          >
            <Stack direction="row" spacing={2} className="view-header">
              <Typography
                className="field-title-list"
                sx={{ width: "20%" }}
                align="center"
              >
                រូបភាព
              </Typography>
              <Typography className="field-title-list" sx={{ width: "30%" }}>
                ឈ្មោះសម្ភារៈ
              </Typography>
              <Typography className="field-title-list" sx={{ width: "15%" }}>
                តម្លៃ/ឯកតា
              </Typography>
              <Typography className="field-title-list" sx={{ width: "15%" }}>
                ចំនួន/ឯកតា
              </Typography>
              <Typography className="field-title-list" sx={{ width: "20%" }}>
                ចំណាំ
              </Typography>
              {/* <Typography className="field-title-list" sx={{ width: "25%" }}>
                ផ្សេងៗ
              </Typography> */}
            </Stack>

            {editData?.map((row, index) => {
              // console.log("row", row);
              return (
                <Stack direction="row" spacing={2} key={index}>
                  <Stack width="20%" direction={`row`} justifyContent="center">
                    <Box
                      sx={{
                        height: "120px",
                        // width: "500px",
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: "2px",
                        boxShadow: 5,
                      }}
                    >
                      <img
                        src={row?.imageSrc ? row?.imageSrc : EmptyImage}
                        alt="Preview"
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Stack>
                  <Stack width="30%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.materialId?.materialEnName || "Unknown Material"}
                    </Typography>
                  </Stack>

                  <Stack width="15%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.costPerUnit?.toFixed(2)} $ /{" "}
                      {row?.unitId?.unitEnName}
                    </Typography>
                  </Stack>
                  <Stack width="15%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.qtyInUnit}{" "}
                      {row?.materialId?.smallUnitId?.unitEnName} /{" "}
                      {row?.unitId?.unitEnName}
                    </Typography>
                  </Stack>
                  <Stack width="20%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.remark}
                    </Typography>
                  </Stack>
                  {/* <Stack width="25%" direction="column" justifyContent="center">
                    <Typography className="field-title" width="100%">
                      {row?.desc}
                    </Typography>
                  </Stack> */}
                </Stack>
              );
            })}
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
